import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import BookingService from "../../../../../services/BookingService";
import { Translate } from "../../../../Enums/Tranlate";
import CourtsService from "../../../../../services/CourtsService";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";

const AddBookingModal = ({ addModal, setAddModal, item, setShouldUpdate }) => {
	const [formData, setFormData] = useState({
		date: "",
		time: "",
		phone: "",
		court: "",
	});
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const [courtsOptions, setCourtsOptions] = useState([]);
	const lang = useSelector((state) => state.auth.lang);
	const courtsService = new CourtsService();
	const bookingService = new BookingService();

	useEffect(() => {
		if (Object.keys(item)?.length === 0) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			setFormData({
				id: item?.id,
				date: item?.date?.split("T")[0],
				time: item?.time,
				phone: item?.phone,
				court: {
					label: item?.court[`name_${lang}`],
					value: item?.court?.id,
				},
			});
		}
		courtsService.getList().then((res) => {
			if (res?.status) {
				let response = res?.data?.data?.data;
				if (!!response.length) {
					setCourtsOptions(
						response?.map((court) => {
							return {
								label: court[`name_${lang}`],
								value: court?.id,
							};
						})
					);
				}
			}
		});
	}, []);

	const submit = (e) => {
		e.preventDefault();
		if (!formData?.court) {
			return;
		}
		let data = {
			date: formData?.date,
			time: formData?.time,
			phone: formData?.phone,
			court_id: formData?.court?.value,
		};

		setLoading(true);
		if (isAdd) {
			bookingService
				.create(data)
				?.then((res) => {
					if (res?.status === 201) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			bookingService
				.update(formData?.id, data)
				?.then((res) => {
					if (res?.status === 200) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addAdmin" : "ar fade addAdmin"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0 text-black fw-bold"
									style={{
										fontSize: "20px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.booking}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>
						<Col md={12} className="mb-2">
							<label>{Translate[lang].court}</label>
							<Select
								value={formData?.court}
								name="type"
								placeholder={Translate[lang]?.select}
								options={courtsOptions}
								onChange={(e) =>
									setFormData({
										...formData,
										court: e,
									})
								}
							/>
						</Col>

						{/* Date */}
						<Col md={6}>
							<label className="text-label">{Translate[lang]?.date}</label>
							<AvField
								type="date"
								placeholder={Translate[lang]?.date}
								bsSize="lg"
								name="date"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.date}
								onChange={(e) =>
									setFormData({
										...formData,
										date: e.target.value,
									})
								}
							/>
						</Col>
						{/*Time */}
						<Col md={6}>
							<label className="text-label">{Translate[lang]?.time}</label>
							<AvField
								type="time"
								placeholder={Translate[lang]?.time}
								bsSize="lg"
								name="time"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.time}
								onChange={(e) =>
									setFormData({
										...formData,
										time: e.target.value,
									})
								}
							/>
						</Col>
						{/* Phone */}
						<Col md={12} className="mb-3">
							<label>{Translate[lang]?.phone}</label>
							<PhoneInput
								country={"kw"}
								enableSearch={true}
								value={formData?.phone}
								onChange={(e) => setFormData({ ...formData, phone: e })}
							/>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="primary"
						type="submit"
						className="w-100"
						disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.booking}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddBookingModal;
